import { render, staticRenderFns } from "./component-b910a4bd.vue?vue&type=template&id=458d66d1&scoped=true&"
import script from "./component-b910a4bd.vue?vue&type=script&lang=js&"
export * from "./component-b910a4bd.vue?vue&type=script&lang=js&"
import style0 from "./component-b910a4bd.vue?vue&type=style&index=0&id=458d66d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458d66d1",
  null
  
)

export default component.exports